import React from "react";
import Seo from "@/components/site/Seo";
import Hero from "@/components/site/Hero";
import ServicesPreview from "@/components/site/ServicesPreview";
import TrainingBand from "@/components/site/TrainingBand";
import TrustBar from "@/components/site/TrustBar";
import CtaBand from "@/components/site/CtaBand";
import OnlineEducation from "@/components/site/OnlineEducation";
import WorkStrip from "@/components/site/WorkStrip";
import { beautySalonSchema } from "@/data/schema";

export default function Home() {
  return (
    <>
      <Seo
        title="Golden Touch Lash & Brow | Lash Extensions & Beauty in Vero Beach, FL"
        description="Discover luxury lash extensions, brow services, beauty treatments and professional lash training at Golden Touch Lash & Brow in Vero Beach, Florida. Book your appointment online."
        path="/"
        jsonLd={[beautySalonSchema()]}
      />
      <Hero />
      <ServicesPreview />
      <TrainingBand />
      <TrustBar />
      <OnlineEducation />
      <section className="bg-onyx pt-10 pb-4 sm:pt-14" aria-label="Our work">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-10">
          <div className="text-center">
            <div className="flex items-center justify-center gap-4">
              <span className="h-px w-10 bg-gold/50" />
              <p className="eyebrow">The Golden Touch</p>
              <span className="h-px w-10 bg-gold/50" />
            </div>
            <h2 className="mt-3 font-display text-4xl md:text-5xl text-ivory">Artistry in Motion.</h2>
            <p className="mt-3 text-xs sm:text-sm tracking-[0.25em] uppercase text-gold">
              A look at our lash, brow &amp; beauty work.
            </p>
          </div>
          <div className="mt-8">
            <WorkStrip />
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
